<template>
  <component :is="component.view" :settings="settings" :componentFullData="componentFullData" @element-click="handleIdReceive" :view="props.view" v-if="component" @click="openEditDialog($event)"/>
</template>

<script setup lang="ts">
import {computed, defineAsyncComponent} from "vue";
import {useDialogStore} from "@/stores/dialogStore";

const component = computed(() => componentsMap[props.type])

const dialogStore = useDialogStore()

const props = defineProps({
  type: { type: String, default: 'text' },
  blockId: { type: Number },
  componentUniqueId: { type: String },
  settings: { type: Object },
  componentFullData: { type: Object },
  view: { type: Boolean }
});

const emit = defineEmits<{
  (e: 'element-click', id: string | number): void
}>()

const handleIdReceive = (id: string | number) => {
  emit('element-click', id)
}

const componentsMap: Record<string, any> = {
  text: {
    view: defineAsyncComponent(() => import('./Text.vue')),
    edit: defineAsyncComponent(() => import('../dialogs/block/TextSettings.vue'))
  },
  button: {
    view: defineAsyncComponent(() => import('./Button.vue')),
    edit: defineAsyncComponent(() => import('../dialogs/block/ButtonSettings.vue'))
  },
  video: {
    view: defineAsyncComponent(() => import('./Video.vue')),
    edit: defineAsyncComponent(() => import('../dialogs/block/VideoSettings.vue'))
  },
  pay: {
    view: defineAsyncComponent(() => import('./Bank.vue')),
    edit: defineAsyncComponent(() => import('../dialogs/block/BankSettings.vue'))
  },
  contacts: {
    view: defineAsyncComponent(() => import('./Contacts.vue')),
    edit: defineAsyncComponent(() => import('../dialogs/block/ContactsSettings.vue'))
  },
  faq: {
    view: defineAsyncComponent(() => import('./FAQ.vue')),
    edit: defineAsyncComponent(() => import('../dialogs/block/FAQSettings.vue'))
  },
  tariffs: {
    view: defineAsyncComponent(() => import('./Tariffs.vue')),
    edit: defineAsyncComponent(() => import('../dialogs/block/TariffsSettings.vue'))
  },
  delimiter: {
    view: defineAsyncComponent(() => import('./Delimiter.vue'))
  }
}

const openEditDialog = (event: any) => {
  if(props.view) {
    return
  } else {
    event.stopPropagation()
    event.preventDefault()
  }
  if(component.value.edit) {
    dialogStore.open(component.value.edit, {
      settings: props.settings,
      componentFullData: props.componentFullData,
      blockId: props.blockId,
      componentUniqueId: props.componentUniqueId
    })
  }
}
</script>

<style scoped lang="sass">

</style>
